// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "1850" ? "monaco-editor" : chunkId) + "." + {"1850": "e56fa031","2545": "1680a5f9","4146": "a68ba55b","4297": "47d55a66","9640": "95fe9399",}[chunkId] + ".css"
}